import { render, staticRenderFns } from "./Galeria2.vue?vue&type=template&id=99530b6e&scoped=true&lang=pug&"
import script from "./Galeria2.vue?vue&type=script&lang=js&"
export * from "./Galeria2.vue?vue&type=script&lang=js&"
import style0 from "./Galeria2.vue?vue&type=style&index=0&id=99530b6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99530b6e",
  null
  
)

export default component.exports